import axios from "axios";
import {Payment} from "../types/types";
import {UseToast} from "../hooks/useToast";

export class PaymentService {
    private readonly url: string;
    private readonly toastHelpers: Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>
    private readonly f: any;

    constructor(f: any, toastHelpers: Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>) {
        this.toastHelpers = toastHelpers;
        this.f = f;
        this.url = '/invoices/payments';
    }

    async create(payment: Payment) {
        return new Promise<Payment>((resolve, reject) => {
            axios.post<Payment>(this.url, payment).then(response => {
                resolve(response.data)
                this.toastHelpers.showCreatedToast(this.f, this.f({ id: 'thePayment' }),'o', true);
            }).catch(error => {
                if (error.response.status === 409) {
                    const message = error.response.data.message;
                    if (message) {
                        this.toastHelpers.showToast('warn', this.f({ id: 'operationUnsuccessful' }), this.f({ id: message }))
                    }
                } else {
                    this.toastHelpers.showCreatedToast(this.f, this.f({ id: 'thePayment' }),'o', false);
                }
                reject(error);
            })
        })
    }

    async update(payment: Payment) {
        // const paymentCopy = {...payment};
        //@ts-ignore
        // paymentCopy.paymentDate = moment(paymentCopy.paymentDate).format('YYYY-MM-DD');
        return new Promise<Payment>((resolve, reject) => {
            axios.put<Payment>(this.url, payment).then(response => {
                resolve(response.data)
                this.toastHelpers.showUpdatedToast(this.f, this.f({ id: 'thePayment' }), 'o',true);
            }).catch(error => {
                if (error.response.status === 409) {
                    const message = error.response.data.message;
                    if (message) {
                        this.toastHelpers.showToast('warn', this.f({ id: 'operationUnsuccessful' }), this.f({ id: message }))
                    }
                } else {
                    this.toastHelpers.showUpdatedToast(this.f, this.f({ id: 'thePayment' }),'o', false);
                }
                reject(error);
            })
        })
    }

    async delete(paymentId: number) {
        return new Promise<boolean>((resolve, reject) => {
            axios.delete<boolean>(this.url + '/' + paymentId).then(response => {
                resolve(response.data)
                this.toastHelpers.showDeletedToast(this.f, this.f({ id: 'thePayment' }), 'o',true);
            }).catch(error => {
                reject(error);
                this.toastHelpers.showDeletedToast(this.f, this.f({ id: 'thePayment' }),'o', false);
            })
        })
    }
}
